/* Ekiboost Newsletter Popup */

var EKI_NL_DELAY = 4000;
var EKI_NL_SUBSCRIBED_KEY = 'ekiboost_nl_subscribed';
var EKI_NL_DISMISSED_KEY = 'ekiboost_nl_dismissed';
var EKI_NL_DISMISS_DAYS = 2;

function ekiShowNewsletter() {
  /* Ne jamais afficher si deja inscrit (permanent) */
  if (localStorage.getItem(EKI_NL_SUBSCRIBED_KEY) === 'true') return;

  /* Ne pas afficher si ferme il y a moins de 2 jours */
  var dismissed = localStorage.getItem(EKI_NL_DISMISSED_KEY);
  if (dismissed) {
    var daysSince = (Date.now() - parseInt(dismissed, 10)) / (1000 * 60 * 60 * 24);
    if (daysSince < EKI_NL_DISMISS_DAYS) return;
  }

  var overlay = document.getElementById('ekiNlOverlay');
  if (!overlay) return;
  overlay.classList.add('eki-active');

  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) ekiCloseNewsletter();
  });

  document.addEventListener('keydown', function handler(e) {
    if (e.key === 'Escape') {
      ekiCloseNewsletter();
      document.removeEventListener('keydown', handler);
    }
  });
}

function ekiCloseNewsletter() {
  var overlay = document.getElementById('ekiNlOverlay');
  var popup = document.getElementById('ekiNlPopup');
  if (!overlay) return;

  popup.style.animation = 'ekiPopOut 0.3s ease forwards';
  overlay.style.animation = 'ekiFadeOut 0.3s ease forwards';

  setTimeout(function() {
    overlay.classList.remove('eki-active');
    overlay.style.animation = '';
    popup.style.animation = '';
  }, 300);

  /* Ferme sans inscription : enregistre la date, reviendra dans 2 jours */
  localStorage.setItem(EKI_NL_DISMISSED_KEY, Date.now().toString());
}

function ekiSubmitNewsletter() {
  var email = document.getElementById('ekiNlEmail').value;
  var form = document.getElementById('ekiNlForm');

  fetch('/contact', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: 'form_type=customer&utf8=%E2%9C%93&contact[email]=' + encodeURIComponent(email) + '&contact[tags]=newsletter,popup'
  }).catch(function() {});

  form.innerHTML = '<div class="eki-nl-success">' +
    '<h4>Merci !</h4>' +
    '<p>Votre code <strong style="font-size:1.2em;">WELCOME10</strong> est pr&ecirc;t !</p>' +
    '<p style="margin-top:8px;font-size:0.78rem;">Utilisez-le lors de votre commande.</p>' +
    '</div>';

  /* Inscrit : ne plus JAMAIS afficher */
  localStorage.setItem(EKI_NL_SUBSCRIBED_KEY, 'true');
  /* Nettoyer le dismissed */
  localStorage.removeItem(EKI_NL_DISMISSED_KEY);

  setTimeout(function() { ekiCloseNewsletter(); }, 4000);
}

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() { ekiShowNewsletter(); }, EKI_NL_DELAY);
});